/*
 * BRANU 公式オーロラプリセット集。aurora-bg.js の後に読み込む。
 *
 *   <script src="aurora-bg.js"></script>
 *   <script src="aurora-presets.js"></script>
 *   <aurora-bg preset="branu"></aurora-bg>   // branu は aurora-bg.js 内蔵（既定）
 *
 * いまは公式プリセットは branu（内蔵・検証済みの基本）のみ。
 * 追加したくなったら Storybook の Foundations > Aurora BG で調整 →「プリセットをコピー」→
 * 下の (A) の位置に definePreset を貼る（名前は用途が分かるものに）。値を精査してから正式採用すること。
 * ※Storybookパネルの「＋ 追加 / 更新」は localStorage（個人・そのブラウザのみ）。全員へ配るのはこのファイルが正。
 */
(function(){
  if(!window.AuroraBg) return;

  /* (A) ここに公式プリセットを追記する（値を精査してから正式採用）。例:
  AuroraBg.definePreset('calm', {
    extends: 'branu',
    params: { warp: 1.1, speed: 0.18, saturation: 0.9, grain: 0.06 }
  });
  */
})();
